<template>
  <div class="">
    <div class="row">
      <div class="col-2 pl-0 pr-8 d-none d-md-inline-block">
        <router-link to="Home">
          <img class="img-fluid " :src="getImgUrl(logo)"/>
        </router-link>
        <!--                <div class="white&#45;&#45;text font-12"> ماشین سازان اصلانیان</div>-->
      </div>
      <div class="col px-0  d-md-block d-none">
        <div class="primary-bg height-header"><!--fixed-top-->
          <div class="container py-0  ">
            <div class="row no-gutters justify-content-between align-items-center">
              <div>

                <div class="row" id="nav-items ">
                                <div class="col-auto ">
                                  <router-link to="Home" class="white--text font-16">خانه</router-link>
                                </div>
                  <div class="col-auto ">
                    <router-link to="allProducts" class="white--text font-16 ">محصولات</router-link>
                  </div>
                  <!--              <div class="col-auto ">
                                  <router-link to="compare" class="white&#45;&#45;text p-link ">
                                    <v-badge
                                        class="badge-style font-16"
                                        :content="numberCompares"
                                    >
                                      مقایسه محصولات
                                    </v-badge>
                                  </router-link>
                                </div>-->
                                <div class="col-auto ">
                                  <router-link to="services" class="white--text font-16">خدمات</router-link>
                                </div>
                  <!--              <div class="col-auto ">
                                  <router-link to="conference" class="white&#45;&#45;text font-16">مشاوره</router-link>
                                </div>-->
                  <div class="col-auto ">
                    <router-link to="aboutUs" class="white--text font-16">درباره ما</router-link>
                  </div>
                  <div class="col-auto ">
                    <router-link to="mission" class="white--text font-16">ماموریت</router-link>
                  </div>
                  <div class="col-auto ">
                    <router-link to="termsAndConditions" class="white--text font-16">اهداف</router-link>
                  </div>
                  <div class="col-auto ">
                    <router-link to="vision" class="white--text font-16">چشم انداز</router-link>
                  </div>
                  <div class="col-auto ">
                    <router-link to="catalog" class="white--text font-16">کاتالوگ</router-link>
                  </div>
                  <div class="col-auto ">
                    <router-link to="photoGallery" class="white--text font-16">گالری محصولات</router-link>
                  </div>
                  <div class="col-auto ">
                    <router-link to="contactUs" class="white--text font-16">ارتباط با ما</router-link>
                  </div>
                  <!--              <div class="nav-item dropdown ">
                                  <router-link
                                      to="aboutUs"
                                      class="nav-link menu dropdown-toggle white&#45;&#45;text pt-3 font-16"
                                      id="homedropdown "
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                  >درباره ما
                                  </router-link>

                                  <div class="dropdown-menu dropdown-content" aria-label="homedropdown">
                                    <router-link to="mission" class="dropdown-item dropdown-text  text-right font-16">ماموریت</router-link>
                                    <div class="dropdown-divider"></div>
                                    <router-link to="termsAndConditions" class="dropdown-item dropdown-text text-right font-16">اهداف
                                    </router-link>
                                    <div class="dropdown-divider"></div>
                                    <router-link to="vision" class="dropdown-item dropdown-text text-right font-16">چشم انداز</router-link>
                                  </div>
                                </div>-->
                </div>
              </div>
              <div>
                <div class="row">
                  <div class="col-auto d-flex align-items-center ">
                    <v-btn
                        elevation="0"
                        color="secondary"
                        class="rounded-lg "
                        @click="overlay = !overlay"
                    >
                      <span class="d-none d-lg-block font-16 ">جستجو</span> <i
                        class="fas fa-search third-color mr-1"></i>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
      <div class="container-fluid primary-bg d-md-none d-block">
        <div class="row no-gutters  align-items-center">
          <div class="col-4">
            <div class="m-1 drawer-btn ">
              <v-btn
                  color="primary"
                  elevation="0"
                  @click.stop="drawer = !drawer"
                  class="nav-btn"
              >
                <i class="fas fa-bars"></i>
              </v-btn>
            </div>
          </div>
          <div class="col-4  text-center">
            <img class="bg-white p-1 " :src="getImgUrl(logo)" height="50"/>
            <!--            <div class="white&#45;&#45;text"> ماشین سازان اصلانیان</div>-->
          </div>
          <div class="col-4 text-left">
            <!--            <i class="fas fa-search third-color font18"></i>-->
            <v-btn
                elevation="0"
                color="secondary"
                class="rounded-lg "
                @click="overlay = !overlay"
            >
              <i class="fas fa-search third-color"></i>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <navigation-drawer v-model="drawer"></navigation-drawer>
    <v-overlay
        id="searchOverLay"
        :absolute="absolute"
        :opacity="opacity"
        :value="overlay"
        :z-index="6">
      <div class="text-right">
        <v-btn
            class="mx-10 container"
            color="primary"
            light
            icon
            @click="overlay = !overlay">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div id="searchFieldsBox" class="row h-75 align-items-center">
        <div class="col-9 col-md-5 mx-auto pr-0">
          <div class="row">
            <div class="col-11 ">
              <v-text-field
                  v-model="searchKeyWord"
                  class="mb-1"
                  clearable
                  flat
                  placeholder="جستجو ..."
                  @keydown="searchProductsByKey($event)">
              </v-text-field>
            </div>
            <div class="col-1 align-self-center">
              <v-btn color="primary" icon @click="searchProducts">
                <i class="fas fa-search"></i>
              </v-btn>
            </div>
          </div>
          <!--          <div class="row">
                        <div class="col-11">
                            <v-text-field
                                    v-model="searchAdvertisingKeyWord"
                                    class=" mb-1"
                                    clearable
                                    flat
                                    placeholder="جستجو آگهی..."
                                    @keydown="searchAdvertising($event)">
                            </v-text-field>
                        </div>
                        <div class="col-1 align-self-center">
                            <v-btn color="primary" icon @click="searchAdvertise">
                                <i class="fas fa-search"></i>
                            </v-btn>
                        </div>
                    </div>-->
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>

import NavigationDrawer from "@/components/navigationDrawer";

export default {
  name: "navBar",
  components: {NavigationDrawer},
  data: () => ({
    drawer: false,
    logo: 'logo-menu2.png',
    overlay: false,
    absolute: false,
    opacity: 0.90,
    searchKeyWord: null,
    numberCompares: "0",
  }),
  mounted() {
    this.checkCompareNumber()

  },
  methods: {
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },

    checkCompareNumber() {
      if (this.$global.comparelist.length > 0) {
        this.numberCompares = this.$global.comparelist.length
      } else {
        this.numberCompares = "0"
      }
    },
    searchProductsByKey(e) {
      if (e.keyCode === 13) {
        this.searchProducts()
      }
    },
    searchProducts() {
      this.$router.replace({path: 'search', query: {KeyWord: this.searchKeyWord}})

      /*      if (this.$router.currentRoute.path === '/search') {
                this.$emit("listenerChild", this.searchKeyWord);
            } else {
                this.$router.replace({path: 'search', query: {KeyWord: this.searchKeyWord}})
            }*/
      this.overlay = false
    },
    /*searchProducts() {
        let requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        fetch(this.$baseUrl + "Home/SearchProduct?keyword=" + this.$route.query.searchNewsKeyWord, requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));
    }*/
  }
}
</script>

<style scoped>

</style>